// extracted by mini-css-extract-plugin
export var formInfo = "fh_KG";
export var formInfo__image = "fh_Kz";
export var formInfo__link = "fh_KF";
export var formInfo__list = "fh_KC";
export var formInfo__sectionHr = "fh_KD";
export var formInfo__services = "fh_Ky";
export var formInfo__title = "fh_KB";